"use client";

import useTranslation from "next-translate/useTranslation";
import React from "react";
import Lottie from "react-lottie";
import lottieNotFound from "utils/lottie/loading-uploader.json";

type UploadFileLottieProps = {
  id?: string;
  onClick?: () => void;
  hideButton?: boolean;
  style?: any;
  size?: number;
  message?: string;
};

const lottieNotFoundOptions = {
  loop: true,
  autoplay: true,
  isClickToPauseDisabled: true,
  animationData: lottieNotFound,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

const UploadFileLottie: React.FC<UploadFileLottieProps> = ({
  id,
  onClick,
  hideButton = false,
  style,
  size = 120,
  message = ""
}) => {
  const { t } = useTranslation("common");

  return (
    <div className="flex w-full flex-col items-center" id={id} style={style}>
      <Lottie options={lottieNotFoundOptions} height={size} width={size} />

      <h6 className="mb-2 mt-3 font-semibold text-blue-600">
        {message || t("tables.notFoundMessage")}
      </h6>

      {hideButton ? (
        <div className="mt-6">
          <button
            className="rounded-md bg-green-500 px-4 py-2 text-base font-semibold text-white shadow-md transition duration-300 ease-in-out hover:bg-green-600 focus:outline-none"
            onClick={onClick}
          >
            {t("tables.tryAgainMessage")}
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default UploadFileLottie;
